// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';

export const FindAStoreIcon = () => {
  return (
    <span className="find-a-store-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        aria-hidden="true"
      >
        <g clipPath="url(#clip0_1054_4385)">
          <path
            d="M8.15179 9.04799V20.312C8.15179 21.272 8.66379 22.104 9.36779 22.104H20.6958C21.3358 22.104 21.9118 21.272 21.9118 20.312V9.04799"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7 7H23V9.048H7V7Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.9847 22.1104V14.4944H14.9927V22.1104"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.9933 22.1104V14.4944H18.0013V22.1104"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1054_4385">
            <rect width="30" height="30" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};

export const HelpIcon = () => {
  return (
    <span className="help-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        aria-hidden="true"
      >
        <g clipPath="url(#clip0_1054_4396)">
          <path
            d="M15 23C19.4183 23 23 19.4183 23 15C23 10.5817 19.4183 7 15 7C10.5817 7 7 10.5817 7 15C7 19.4183 10.5817 23 15 23Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.6719 12.6001C12.86 12.0654 13.2312 11.6146 13.7198 11.3274C14.2085 11.0402 14.783 10.9352 15.3416 11.031C15.9002 11.1269 16.4069 11.4173 16.7719 11.8509C17.1369 12.2845 17.3367 12.8333 17.3359 13.4001C17.3359 15.0001 14.9359 15.8001 14.9359 15.8001"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M15 19H15.008" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
          <clipPath id="clip0_1054_4396">
            <rect width="30" height="30" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};
